import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ButtonIconSolidLarge from '../../../components/common/ButtonIconSolid/ButtonIconSolidLarge';
import { Icon } from '../../../components/icon/icon';
import SelectionBasic from '../../../components/common/SelectionBasic/SelectionBasic';
import ButtonLink from '../../../components/common/ButtonLink/ButtonLink';
import Tag from '../../../components/common/Tag/Tag';
import ButtonPrimaryLarge from '../../../components/common/ButtonPrimary/ButtonPrimaryLarge';
import ButtonSecondaryLarge from '../../../components/common/ButtonSecondary/ButtonSecondaryLarge';
import {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { Image, Tooltip } from 'antd';
import PreviewImage from '../../../components/common/PreviewImage/PreviewImage';
import { cn } from '../../../utils/string/cn.utils';
import useModalAddress from '../../../components/common/ModalAddress/ModalAddress';
import { fetchListAddress } from '../../../store/actions/address.action';
import { openMessageWarning } from '../../../components/common/Message/openMessageWarning';
import { addToCart } from '../../../store/actions/room.action';
import { openMessageSuccess } from '../../../components/common/Message/openMessageSuccess';
// import { openDrawerCart } from '../../CartPage/components/DrawerCart/DrawerCart';
import ROUTER from '../../../routers/Routers';
import { useNavigate } from 'react-router-dom';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { DetailProductPageContext } from '../DetailProductPageUpgrage';
import {
  createVariantIndex,
  extractVariantAttrs,
  findVariantBySelection,
  findVariantInfo,
  getDefaultVariant,
} from '../../../utils/variant/variant.util';
import {
  buildVariantTitle,
  transformVariantData,
} from '../../../utils/variant/transformVariantData';
import { roundTo } from '../../../utils/geometry/epsilon';
import DropdownFilter from '../../../components/common/DropdownFilter/DropdownFilter';
import i18n from '../../../languages/i18n';
import { useDeviceType } from '../../../hooks/useDeviceType';
import useDrawerCard from '../../CartPage/components/DrawerCart/DrawerCart';
import { convertForeignCurrency } from '../../../utils/currency/currency.utils';

const items = [
  {
    key: 0,
    label: (
      <div className="flex items-center gap-[8px]">
        <span className="w-[20px] h-[20px] flex items-center justify-center">
          <Icon.ICEngineering />
        </span>
        <span className="text-body-medium font-semibold">
          {i18n.t('Constant.Fitta installation')}
        </span>
      </div>
    ),
  },
  {
    key: 1,
    label: (
      <div className="flex items-center gap-[8px]">
        <span className="w-[20px] h-[20px] flex items-center justify-center">
          <Icon.ICEngineering />
        </span>
        <span className="text-body-medium font-semibold">
          {i18n.t('Constant.Self-installation')}
        </span>
      </div>
    ),
  },
];

const SectionVariants = () => {
  const { openDrawerCart } = useDrawerCard();
  const { variant, setVariant, variantIndex, setVariantIndex } = useContext(
    DetailProductPageContext
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const device = useDeviceType();

  const [preview, setPreview] = useState();
  const [imageList, setImageList] = useState([]);
  const [showPreview, setShowPreview] = useState(false);

  const [prices, setPrices] = useState([]);

  const { detail } = useSelector(state => state.saleProduct);
  const { products } = useSelector(state => state.product);
  const { listAddress } = useSelector(state => state.address);
  const { accessToken } = useSelector(state => state.auth);

  const { variants, meta } = useMemo(
    () => transformVariantData(detail?.data?.meta_data, detail?.data?.variants),
    [detail]
  );

  const {
    handleData,
    setListAdd,
    // setListAdd,
  } = useModalAddress({
    handleUpdateAddress: addressId => {
      // dispatch(
      //   updateOrder({ billAddress: addressId, id: order.detail.id })
      // ).then(action => {
      //   if (action.payload?.data) {
      //     openMessageSuccess({ content: t('Successfully') });
      //   }
      // });
    },
  });

  // Handler khi click vào card
  const handleCardClick = e => {
    if (detail?.data?.id) {
      const product = products?.data?.find(item =>
        // Array.isArray(item.types) &&
        item.types.some(value => value?.id === detail?.data?.type)
      );
      // Navigate đến designer page với design_id
      const url =
        ROUTER.DESIGN +
        '/' +
        (product.type_design || design.data?.type_design) +
        `?sale_product=${detail?.data?.id}`;
      if (e?.ctrlKey || e?.metaKey) {
        window.open(url, '_blank');
      } else {
        navigate(url);
      }
    }
  };

  // useEffect(() => {
  //   if (accessToken)
  //     if (listAddress.isNeedReloadData) dispatch(fetchListAddress());
  // }, [listAddress]);

  // useEffect(() => {
  //   if (listAddress?.data?.length > 0) {
  //     setListAdd([...(listAddress.data ?? [])]);
  //     handleData();
  //   }
  // }, [listAddress]);

  useEffect(() => {
    const images = [
      ...((detail.data?.image_urls?.length ? detail.data?.image_urls : null) ??
        (detail.data?.thumbnail_url ? [detail.data?.thumbnail_url] : null) ??
        []),
      ...(detail.data?.variants?.map(item => item.image)?.filter(Boolean) ||
        []),
    ];
    setImageList(images);
    if (images.length) {
      setPreview(images[0]);
    } else {
      setPreview(null);
    }
  }, [detail]);

  useEffect(() => {
    if (detail.data) {
      setPrices([
        {
          icon: <Icon.ICEngineering />,
          label: t('Constant.Fitta installation'),
          description: t(
            'Constant.Fitta will deliver it to you and complete the installation.'
          ),
          price_after: detail.data.price_after || 0,
          price_original: detail.data.price_original || 0,
        },
      ]);
    }
  }, [detail]);

  useEffect(() => {
    const defaultVariant = variants.find(({ is_default }) => is_default);
    if (defaultVariant) {
      setVariant(defaultVariant);
    } else {
      setVariant(variants[0]);
    }
  }, [variants]);

  useEffect(() => {
    const button = document.getElementById('buttonAddCart');
    const bubbleChat = document.getElementById('main-chat-bubble');
    const banner = document.getElementById('floatingBannerPrice');
    if (!button) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (device === 'mobile') {
            return;
          }
          // setIsButtonVisible(entry.isIntersecting);
          if (banner) {
            if (entry.isIntersecting) {
              banner.classList.add('opacity-0');
              banner.classList.add('invisible');
              banner.classList.remove('opacity-100');
              banner.classList.remove('visible');
              banner.classList.add('translate-y-[100px]');
            } else {
              banner.classList.add('opacity-100');
              banner.classList.add('visible');
              banner.classList.remove('translate-y-[100px]');
              banner.classList.remove('opacity-0');
              banner.classList.remove('invisible');
            }
          }
          if (bubbleChat) {
            bubbleChat.style.bottom = entry.isIntersecting ? '75px' : '200px';
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    );

    observer.observe(button);

    return () => {
      observer.unobserve(button);
    };
  }, [device]);

  return (
    <>
      <section className="flex lg:flex-row flex-col lg:px-[80px] lg:py-[40px] items-start lg:gap-[40px] self-stretch">
        <div className="preview flex flex-col items-start gap-[16px] grow self-stretch p-[16px] md:px-[20px] lg:!p-0">
          <div className="main-image flex lg:h-[710px] h-[370px] items-center justify-center gap-[40px] self-stretch relative">
            {/* <Image height={776} src={preview} preview/> */}
            <PreviewImage
              open={showPreview}
              onClose={setShowPreview}
              imageList={imageList}
              current={imageList.findIndex(item => item === preview)}
              setCurrent={index => setPreview(imageList[index])}
              className="lg:!h-[710px] !h-[370px] !w-auto object-contain"
            />
          </div>
          <div className="sub-image flex lg:flex-row flex-col items-center gap-[8px] self-stretch">
            <div className="flex items-start gap-[8px] grow self-stretch flex-wrap">
              {imageList.map((item, index) => (
                <div
                  className={cn(
                    'w-[56px] h-[56px] flex items-center rounded-[4px] overflow-hidden border-[2px] border-solid border-transparent hover:border-outline-brand-primary transition-all duration-300 cursor-pointer',
                    preview === item ? 'border-outline-brand-primary' : ''
                  )}
                  onClick={() => {
                    setPreview(item);
                  }}
                >
                  <img
                    src={item}
                    alt=""
                    key={index}
                    className="h-[52px] self-stretch object-cover aspect-square"
                  />
                </div>
              ))}
            </div>
            <div className="flex justify-end items-center gap-[16px]">
              <ButtonIconSolidLarge
                icon={<Icon.ICNavigateBefore />}
                disabled={imageList.findIndex(item => item === preview) === 0}
                classNames={{ icon: 'opacity-80', button: 'shadow-none' }}
                onClick={() => {
                  const current = imageList.findIndex(item => item === preview);
                  if (current > 0) {
                    setPreview(imageList[current - 1]);
                  }
                }}
              />

              <ButtonIconSolidLarge
                icon={<Icon.ICNavigateNext />}
                disabled={
                  imageList.findIndex(item => item === preview) ===
                  imageList.length - 1
                }
                classNames={{ icon: 'opacity-80', button: 'shadow-none' }}
                onClick={() => {
                  const current = imageList.findIndex(item => item === preview);
                  if (current + 1 < imageList.length) {
                    setPreview(imageList[current + 1]);
                  }
                }}
              />

              <ButtonIconSolidLarge
                icon={<Icon.ICOpenFullScreen />}
                classNames={{ icon: 'opacity-80', button: 'shadow-none' }}
                onClick={() => setShowPreview(true)}
              />
            </div>
          </div>
        </div>
        <div className="flex lg:w-[464px] flex-col items-start self-stretch">
          <div className="lg:rounded-[16px] bg-white flex items-start flex-col self-stretch lg:h-fit">
            <div className="flex lg:p-[40px] lg:pb-[20px] p-[16px] md:px-[20px] flex-col justify-end items-start gap-[24px] self-stretch">
              <span className="text-headline-small !font-bold">
                {getValueFromString(detail.data.name)}
              </span>
              <span className="text-body-medium line-clamp-4">
                {getValueFromString(detail.data.description)}
              </span>
            </div>
            <div className="flex lg:px-[40px] lg:py-[20px] p-[16px] md:px-[20px] flex-col gap-[16px] self-stretch border-t-[1px] border-t-solid border-outline-default-divider">
              {/* {Array.isArray(detail.data?.sizes) &&
              detail.data?.sizes?.length > 0 && (
                <div className="flex flex-col items-start gap-[12px] self-stretch">
                  <span className="text-body-medium font-semibold">
                    {t('Size')}
                  </span>
                  <div className="flex items-start self-stretch gap-[8px]">
                    {detail.data?.sizes?.map((item, index) => {
                      return (
                        <SelectionBasic
                          label={item.name}
                          actived={variant?.name === item.name}
                          onClick={() => setVariant(item)}
                        />
                      );
                    })}
                  </div>
                </div>
              )} */}
              <RenderVariants meta={meta} variants={variants} />

              <div className="flex flex-col items-start gap-[12px] self-stretch">
                <span className="text-body-medium font-semibold">
                  {t('Delivery')}
                </span>
                <div className="flex items-start self-stretch gap-[8px]">
                  {/* <SelectionBasic
                  label={
                    <div className="flex items-center gap-[8px]">
                      <span className="w-[16px] h-[16px]">
                        <Icon.ICTool />
                      </span>
                      <span className="text-label-medium">
                        {t('Self-installation')}
                      </span>
                    </div>
                  }
                  actived={true}
                /> */}
                  <DropdownFilter
                    trigger={['click']}
                    menu={{
                      items: (detail?.data?.delivery_type !== undefined &&
                      detail?.data?.delivery_type !== null
                        ? [items[detail?.data?.delivery_type]]
                        : items
                      ).map(item => {
                        return {
                          key: item?.key,
                          label: (
                            <div className="p-[8px] flex items-start ">
                              {item?.label}
                            </div>
                          ),
                          onClick: () => {},
                        };
                      }),
                    }}
                    size="large"
                    className={
                      'text-black-medium rounded-[8px] !p-[16px] bg-primary-primaryFill grow border-none items-start justify-between self-stretch'
                    }
                    value={getValueFromString(
                      items.find(item => !item.key)?.label ?? items[0].label
                    )}
                  />
                  {/* <SelectionBasic
                    label={
                      <div className="flex items-center gap-[8px]">
                        <span className="w-[16px] h-[16px]">
                          <Icon.ICEngineering />
                        </span>
                        <span className="text-label-medium">
                          {t('Constant.Fitta installation')}
                        </span>
                      </div>
                    }
                    actived={true}
                  /> */}
                </div>
              </div>
            </div>

            <div className="flex lg:px-[40px] lg:py-[20px] p-[16px] md:px-[20px] flex-col items-start gap-[16px] self-stretch border-t-[1px] border-t-solid border-outline-default-divider">
              <div className="flex flex-col justify-center items-start gap-[8px]">
                {(() => {
                  let priceAfter = 0;
                  let priceOriginal = 0;
                  if (detail?.data?.is_combo_product) {
                    detail?.data?.sizes?.forEach(size => {
                      priceOriginal += size.price || 0;
                    });
                    priceAfter = detail.data.price_after || priceOriginal;
                  } else if (variant) {
                    priceAfter = variant.discount;
                    priceOriginal = variant.price;
                  } else if (prices[0]?.price_after) {
                    priceAfter = prices[0].price_after;
                    priceOriginal = prices[0].price_original || priceAfter;
                  }
                  if (!priceAfter || priceAfter > priceOriginal)
                    return <i>{t('Constant.Contact for more information')}</i>;
                  return (
                    <>
                      {priceAfter !== priceOriginal && (
                        <span className="text-body-large line-through text-black-medium">
                          {convertForeignCurrency(priceOriginal)}
                        </span>
                      )}
                      <div className="flex items-center gap-[16px]">
                        <span className="text-headline-small">
                          {convertForeignCurrency(priceAfter)}
                        </span>
                        {priceAfter !== priceOriginal && (
                          <Tag
                            label={
                              <div className="flex items-center justify-center gap-[4px]">
                                <span className="flex w-[16px] h-[16px]">
                                  <Icon.ICPercentDiscount />
                                </span>
                                <span className="text-label-medium">
                                  {t('{{x}}% Off', {
                                    x: roundTo(
                                      ((priceOriginal - priceAfter) /
                                        priceOriginal) *
                                        100,
                                      0
                                    ),
                                  })}
                                </span>
                              </div>
                            }
                            className="py-[4px] px-[8px] rounded-[4px] bg-Accents-Red-Fill-Varient text-Accents-On-Red-Fill"
                          />
                        )}
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>
            <div className="flex lg:px-[40px] lg:py-[20px] p-[16px] md:px-[20px] flex-col items-start gap-[16px] self-stretch border-t-[1px] border-t-solid border-outline-default-divider">
              <div className="flex items-start gap-[8px] self-stretch flex-nowrap">
                <span className="min-w-[24px] h-[24px] text-primary-primary">
                  <Icon.ICDesign />
                </span>
                {/* {deliveryAddress ? (
                <span className="text-body-medium">
                  {`${deliveryAddress?.addressFull ?? '...'}`}{' '}
                  <ButtonLink
                    onClick={() => {
                      openModalListAddress(true);
                    }}
                    title={t('Change')}
                    className="text-Accents-Blue"
                  />
                </span>
              ) : (
                <ButtonLink
                  onClick={() => {
                    openModalListAddress(true);
                  }}
                  title={t('Add address')}
                  className="text-Accents-Blue"
                />
              )} */}
                <span className="text-body-medium">
                  Hỗ trợ đo đạc tận nhà: <b>Khu vực HCM và các tỉnh lân cận</b>
                </span>
              </div>
              <div className="flex items-start gap-[8px] self-stretch flex-nowrap">
                <span className="w-[24px] h-[24px] text-primary-primary">
                  <Icon.ICPrice />
                </span>
                <span className="text-body-medium">
                  Miễn phí vận chuyển: <b>Khu vực nội thành TP HCM</b>
                </span>
              </div>
              {/* <div className="flex items-start gap-[8px] self-stretch flex-nowrap">
              <span className="w-[24px] h-[24px] text-primary-primary">
                <Icon.ICDelivery />
              </span>
              <span className="text-body-medium">
                {t('Estimated delivery date')}:{' '}
                <span className="font-semibold">24-03-2026</span>
              </span>
            </div> */}
            </div>
            <div className="flex flex-col md:flex-row lg:flex-col lg:px-[40px] lg:pt-[20px] p-[16px] md:px-[20px] items-center gap-[16px] self-stretch border-t-[1px] border-t-solid border-outline-default-divider">
              <ButtonPrimaryLarge
                title={t('Add to Cart')}
                posIcon={<Icon.ICAddToCart />}
                className="grow self-stretch"
                id={'buttonAddCart'}
                onClick={() => {
                  if (!accessToken) {
                    openMessageWarning({
                      content: t('Warning.login_to_add_cart'),
                    });
                  } else {
                    if (detail?.data?.id) {
                      dispatch(
                        addToCart({
                          designId: detail.data.id,
                          variantId: variant?.id,
                        })
                      ).then(action => {
                        if (action.payload?.data)
                          openMessageSuccess({
                            content: t('Success.added_to_cart'),
                          });
                        openDrawerCart();
                      });
                    }
                  }
                }}
              />
              {detail?.data?.sale_type === 'design' ? (
                <ButtonSecondaryLarge
                  title={t('Customize')}
                  className="grow self-stretch"
                  posIcon={<Icon.ICModule />}
                  onClick={e => {
                    handleCardClick(e);
                  }}
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </section>
      <FloatingBannerPrice prices={prices} />
    </>
  );
};

export default SectionVariants;

const FloatingBannerPrice = ({ prices }) => {
  const { openDrawerCart } = useDrawerCard();

  const { variant, setVariant, variantIndex, setVariantIndex } = useContext(
    DetailProductPageContext
  );
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user, accessToken } = useSelector(state => state.auth);
  const { detail } = useSelector(state => state.saleProduct);

  return (
    <section
      id="floatingBannerPrice"
      className={cn(
        'lg:flex hidden p-[24px] justify-between items-center fixed left-[24px] right-[24px] bottom-[12px] rounded-[20px] z-[1000] bg-white shadow-widget16 duration-300 transition-all'
      )}
    >
      <div className="flex items-start gap-[24px] self-stretch">
        <div className="flex w-[48px] h-[48px] items-center justify-center">
          <img
            src={detail.data?.thumbnail_url}
            alt={getValueFromString(detail.data.name)}
            className="object-fill aspect-square"
          />
        </div>
        <div className="flex flex-col justify-center items-start gap-[8px]">
          <span className="text-title-small !font-bold">
            {getValueFromString(detail.data.name)}
          </span>
          <div className="flex items-center gap-[8px]">
            {(() => {
              if (!variant) return null;

              return (
                <div className="flex items-center gap-[4px]">
                  <span className="text-body-small font-normal">
                    {t(variant.title)}:
                  </span>
                </div>
              );
            })()}
            <div className="flex items-center gap-[4px]">
              <span className="text-body-small font-normal">
                {t('Delivery')}:
              </span>
              <span className="text-body-small font-semibold">
                {t('Constant.Fitta installation')}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center gap-[40px]">
        <div className="flex items-center gap-[16px]">
          {(() => {
            let priceAfter = 0;
            let priceOriginal = 0;
            if (detail?.data?.is_combo_product) {
              detail?.data?.sizes?.forEach(size => {
                priceOriginal += size.price || 0;
              });
              priceAfter = detail.data.price_after || priceOriginal;
            } else if (variant) {
              priceAfter = variant.discount;
              priceOriginal = variant.price;
            } else if (prices[0]?.price_after) {
              priceAfter = prices[0].price_after;
              priceOriginal = prices[0].price_original || priceAfter;
            }
            console.log(priceAfter !== priceOriginal);
            if (!priceAfter || priceAfter > priceOriginal)
              return <i>{t('Constant.Contact for more information')}</i>;
            return (
              <>
                {priceAfter !== priceOriginal && (
                  <span className="text-body-large line-through text-black-medium">
                    {convertForeignCurrency(priceOriginal)}
                  </span>
                )}
                <div className="flex items-center gap-[16px]">
                  <span className="text-headline-small">
                    {convertForeignCurrency(priceAfter)}
                  </span>
                  {priceAfter !== priceOriginal && (
                    <Tag
                      label={
                        <div className="flex items-center justify-center gap-[4px]">
                          <span className="flex w-[16px] h-[16px]">
                            <Icon.ICPercentDiscount />
                          </span>
                          <span className="text-label-medium">
                            {t('{{x}}% Off', {
                              x: roundTo(
                                ((priceOriginal - priceAfter) / priceOriginal) *
                                  100,
                                0
                              ),
                            })}
                          </span>
                        </div>
                      }
                      className="py-[4px] px-[8px] rounded-[4px] bg-Accents-Red-Fill-Varient text-Accents-On-Red-Fill"
                    />
                  )}
                </div>
              </>
            );
          })()}
        </div>
        <ButtonPrimaryLarge
          title={t('Add to Cart')}
          posIcon={<Icon.ICAddToCart />}
          className="grow self-stretch"
          onClick={() => {
            if (!accessToken) {
              openMessageWarning({
                content: t('Warning.login_to_add_cart'),
              });
            } else {
              if (detail?.data?.id) {
                dispatch(
                  addToCart({
                    designId: detail.data.id,
                    variantId: variant?.id,
                  })
                ).then(action => {
                  if (action.payload?.data)
                    openMessageSuccess({
                      content: t('Success.added_to_cart'),
                    });
                  openDrawerCart();
                });
              }
            }
          }}
        />
      </div>
    </section>
  );
};

const RenderVariants = ({ meta, variants }) => {
  const { variant, setVariant, variantIndex, setVariantIndex } = useContext(
    DetailProductPageContext
  );
  const { t } = useTranslation();

  const handlClickVariant = useCallback(
    (newNameChoosed, attrName) => {
      const updatedType = Object.entries(variant?.type ?? {}).reduce(
        (acc, [key, attribute]) => {
          acc[key] =
            attribute.attrName === attrName
              ? { ...attribute, value: newNameChoosed }
              : attribute;
          return acc;
        },
        {}
      );

      const newTitle = buildVariantTitle(updatedType);
      const newVariant = variants?.find(item => item.title === newTitle);
      if (newVariant) {
        setVariant(newVariant);
      }
    },
    [variant, variants]
  );
  return (
    <>
      {Object.entries(meta ?? {})?.map(([attrName, attributes], index) => {
        return (
          <div
            key={index}
            className="flex flex-col items-start gap-[12px] self-stretch"
          >
            <div className="flex items-center gap-[8px] self-stretch">
              <span className="text-body-medium">{t(attrName)}:</span>
              <span className="text-body-medium font-semibold">
                {variant?.title}
              </span>
            </div>
            <div className="flex flex-col items-start gap-[8px] self-stretch">
              <div className="flex items-end self-stretch gap-[8px] flex-wrap">
                {attributes?.map((item, index) => {
                  if (item.icon) {
                    return (
                      <div className="flex flex-col items-start justify-start overflow-hidden rounded-[4px] w-48">
                        {!!item.value && (
                          <span className="text-label-small">{item.value}</span>
                        )}
                        <div
                          className={cn(
                            'flex w-[48px] h-[48px] aspect-square rounded-[4px] border-[2px] border-solid shadow-dropshadow2 overflow-hidden hover:border-outline-brand-primary cursor-pointer',
                            variant?.title
                              ?.split('|')
                              .map(item => item.trim())
                              .includes(item.value) &&
                              'border-outline-brand-primary'
                          )}
                          onClick={() => {
                            handlClickVariant(item.value, attrName);
                          }}
                        >
                          <img
                            src={item.icon}
                            alt={item.value}
                            className="object-contain w-full"
                          />
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <SelectionBasic
                        label={item.value ?? index}
                        actived={variant?.title
                          ?.split('|')
                          .map(item => item.trim())
                          .includes(item.value)}
                        onClick={() => {
                          handlClickVariant(item.value, attrName);
                        }}
                      />
                    );
                  }
                })}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};
